// extracted by mini-css-extract-plugin
export default {"wrapper":"cn-z","response":"dn-z","error":"en-z","disabled":"fn-z","buttons":"gn-z","feedbackQuestionSection":"hn-z","yesNoWrapper":"in-z"};